module.exports = __webpack_public_path__ + "img/truck.03348697.jpg";